import React, { useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../models/RouteComponent";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { Dialog } from 'primereact/dialog';
import EmployeeDocumentsSignedItem from "./Employee-Documents-Signed-item";
import { DocumentSigned } from "../../service/documentsSignedService";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";

export default function EmployeeDocumentsSignedTable(props: RouteComponentProps) {
  const [reload, setReload] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<DocumentSigned | null>(null);
  const [showViewDialog, setShowViewDialog] = useState(false);
  const [globalLoading, setGlobalLoading] = useState(false);
  const toast = useRef<Toast>(null);

  const url = 'documents-signed';

  const itemSelected = (row: { value: DocumentSigned }) => {
    setSelectedRecord(row.value);
    setShowViewDialog(true);
  }

  const contextItemSelected = (row: { value: DocumentSigned }) => {
    setSelectedRecord(row.value);
  }

  const contextItems = () => {
    return [
      {
        label: 'View',
        icon: 'pi pi-eye',
        command: () => {
          setShowViewDialog(true);
        }
      }
    ];
  }

  const baseFilter = { }

  const columns: GenericTableColumns[] = [
    {
      field: 'document_name',
      header: 'Document Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: false,
    },
    {
      field: 'document_appointment_name',
      header: 'Appointment',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: false,
    },
    {
      field: 'site_name',
      header: 'Site',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: false,
    },
    {
      field: 'signed_at',
      header: 'Signed At',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: false,
      filter: false,
    },
    {
      field: 'created_at',
      header: 'Created At',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: false,
      filter: false,
    }
  ];

  return (
    <React.Fragment>
      <GenericTableView
        dataKey="document_id"
        reload={reload}
        baseFilters={baseFilter}
        queryParams={{
          employeeId: props.employee.id || '',
          signed: "true"
        }}
        sortByField="signed_at"
        url={url}
        columns={columns}
        contextItems={contextItems}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />
      {showViewDialog && selectedRecord?.document_id && (
      <Dialog
        header={selectedRecord.document_name}
        visible={showViewDialog}
        style={{ width: '90vw', height: '90vh' }}
        modal
        onHide={() => setShowViewDialog(false)}
      >
        <EmployeeDocumentsSignedItem
          id={selectedRecord.document_id}
          record={selectedRecord}
          setGlobalLoading={setGlobalLoading}
        />
      </Dialog>
      )}
      <Toast ref={toast} />
    </React.Fragment>
  );
}
